/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useMemo, useState } from 'react';
import moment from 'moment-timezone';
import 'react-bootstrap/cjs/divWithClassName';
import BaseModal from '../BaseModal/BaseModal';
import Checkbox from '../../form/Checkbox';

import './RouteSlotModal.scss';

const RouteSlotModal = ({ onClose, onConfirm, shiftToRoute, badge, isDailyFeed }) => {
	const { shift } = shiftToRoute;
	const [routeShiftMed, setRouteToShiftMed] = useState(false);

	const isReadyToSubmit = !!routeShiftMed;

	const shiftType = useMemo(() => {
		if (isDailyFeed) {
			return shift.resource_type;
		}
		return shift.shift_specialty
			? `${shift.shift_resource_type}-${shift.shift_specialty}`
			: `${shift.shift_resource_type}`;
	}, [shift, isDailyFeed]);

	return (
		<BaseModal
			title="Modify Route"
			className="route-slot-modal"
			primaryActionLabel="Confirm"
			onPrimaryAction={isReadyToSubmit ? onConfirm : null}
			primaryActionDisabled={!isReadyToSubmit}
			secondaryActionLabel="Cancel"
			onSecondaryAction={onClose}
			onHide={onClose}
		>
			<div className="route-slot-modal__container">
				<div className="route-slot-modal__column">
					Facility:<span> {shift.facility_name}</span>
				</div>
				<div className="route-slot-modal__column">
					Date:<span> {moment(shift.start_time).tz(shift.facility_timezone).format('dddd[,] MMMM Do YYYY')}</span>
				</div>
				<div className="route-slot-modal__column">
					Time:<span> {`${shift.formatted_start_time} - ${shift.formatted_end_time}`}</span>
				</div>
				<div className="route-slot-modal__column">
					Shift Type:
					<span> {shiftType}</span>
				</div>
				<div className="route-slot-modal__column">
					<div className="route-slot-modal__badge-column">
						Current Route:
						<div className="route-slot-modal__badge-container">{badge}</div>
					</div>
				</div>
				<hr />
				<span className="route-slot-modal__route-label">Route shift to:</span>
				<div className="route-slot-modal__column">
					<label className="route-slot-modal__route-shift">
						<Checkbox
							className="route-checkbox"
							checked={routeShiftMed}
							value={routeShiftMed}
							handleChange={() => {
								setRouteToShiftMed(!routeShiftMed);
							}}
						/>
						ShiftMed
					</label>
				</div>
			</div>
		</BaseModal>
	);
};

export default RouteSlotModal;
